import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";

import {
  Dialog,
  DialogTitle,
  Typography,
  DialogContent,
  Button,
} from "@material-ui/core";

const styles = (theme) => ({});

function InstructorCourseSettingsDialogs(props) {
  return (
    <>
      <Dialog
        open={props.studentCategoriesDialog}
        onClose={() => {
          props.closeStudentCategoriesDialog();
        }}
      >
        <DialogTitle>
          <Typography style={{ fontSize: "1.3rem" }} color="primary">
            How does choosing category labels work?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>
            Force students to select their own category labels. If the student
            does not currently have their category labels selected, they will be
            required to choose the next time they enter this course. Optionally,
            you can add a google document link that will be shared to the
            student, to view category and label descriptions. Ensure it is a
            public document.
          </Typography>
        </DialogContent>
        <Button
          onClick={() => {
            props.closeStudentCategoriesDialog();
          }}
          color="primary"
        >
          Close
        </Button>
      </Dialog>

      {/* <Dialog
        open={props.forcePIDDialog}
        onClose={() => {
          props.closeForcePIDDialog();
        }}
      >
        <DialogTitle>
          <Typography style={{ fontSize: "1.3rem" }} color="primary">
            What is force PID?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>
            This will require students to enter their PID for their account.
          </Typography>
        </DialogContent>
        <Button
          onClick={() => {
            props.closeForcePIDDialog();
          }}
          color="primary"
        >
          Close
        </Button>
      </Dialog> */}

      <Dialog
        open={props.restrictDomainDialog}
        onClose={() => {
          props.closeRestrictDomainDialog();
        }}
      >
        <DialogTitle>
          <Typography style={{ fontSize: "1.3rem" }} color="primary">
            What is restrict domain?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>
            Restricting domain will only allow students with a certain email
            domain to join this course. If this is enabled, type in a domain
            email (ex: @ucsd.edu). Also, type in an override code which can be
            used to allow students without the domain to still join the course.
          </Typography>
        </DialogContent>
        <Button
          onClick={() => {
            props.closeRestrictDomainDialog();
          }}
          color="primary"
        >
          Close
        </Button>
      </Dialog>

      <Dialog
        open={props.anonVotingDialog}
        onClose={() => {
          props.closeAnonVotingDialog();
        }}
      >
        <DialogTitle>
          <Typography style={{ fontSize: "1.3rem" }} color="primary">
            Who are anonymous users?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>
            Enabing anonymous users will allow students who are not signed into
            WebClicker with an account to join the course and vote. Students can 
            use the provided URL to automaticlly join the course as an anonymous 
            user. You can also choose to only allow anonymous users to join the 
            course; students who are logged into an account on WebClicker will 
            not be able to search for or join the course. If students who are 
            logged in have already joined the course, you will have the option 
            of removing them from the course when you save your settings.
          </Typography>
        </DialogContent>
        <Button
          onClick={() => {
            props.closeAnonVotingDialog();
          }}
          color="primary"
        >
          Close
        </Button>
      </Dialog>

      <Dialog
        open={props.geofencingDialog}
        onClose={() => {
          props.closeGeofencingDialog();
        }}
      >
        <DialogTitle>
          <Typography style={{ fontSize: "1.3rem" }} color="primary">
            What is geofencing?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>
            Geofencing is a location-based feature that allows you to define a
            virtual boundary to control access to your course. When enabled,
            once you start the session it will record your location and students
            will be required to be within a certain distance of that
            base-station. If they are not within the specified distance, they
            will not be able to vote, and their vote record will be set to "G"
            followed by their vote choice (e.g., "GB" for "B").
          </Typography>
        </DialogContent>
        <Button
          onClick={() => {
            props.closeGeofencingDialog();
          }}
          color="primary"
        >
          Close
        </Button>
      </Dialog>

      <Dialog
        open={props.pollHistoryDialog}
        onClose={() => {
          props.closePollHistoryDialog();
        }}
      >
        <DialogTitle>
          <Typography style={{ fontSize: "1.3rem" }} color="primary">
            What is student poll history?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>
            Enabling this allows students to view their poll history for all
            sessions of this course. Students will have detailed view of what
            votes they made for polls and sessions.
          </Typography>
        </DialogContent>
        <Button
          onClick={() => {
            props.closePollHistoryDialog();
          }}
          color="primary"
        >
          Close
        </Button>
      </Dialog>

      <Dialog
        open={props.screenshotDialog}
        onClose={() => {
          props.closeScreenshotDialog();
        }}
      >
        <DialogTitle>
          <Typography style={{ fontSize: "1.3rem" }} color="primary">
            How do screenshots work?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>
            This feature will only work if you are logged in with a Google
            account. The first time you enable screenshots, a prompt will 
            appear asking you to grant WebClicker access to your Google Drive. 
            You must grant access in order for screenshots to work, but keep in 
            mind WebClicker will only have access to any folders it creates, not 
            your entire drive. A new folder, "Webclicker", will be created in your 
            Google Drive where all screenshots will be stored; subfolders will be 
            created for each course you enable screenshots for. When the screenshots 
            option is enabled, screenshots will be displayed alongside their respective polls.
            However, in order to take a screenshot on your device, you will need
            to select a device from the "Screenshot device" dropdown; you can add your 
            current device to the dropdown by entering a name for it in the 
            "This device's name" textbox and clicking the checkmark. Additionally, when you
            start each session, you will need to allow screenshare of the
            screen. 
          </Typography>
        </DialogContent>
        <Button
          onClick={() => {
            props.closeScreenshotDialog();
          }}
          color="primary"
        >
          Close
        </Button>
      </Dialog>
      <Dialog
        open={props.archiveCourseDialog}
        onClose={() => {
          props.closeArchiveCourseDialog();
        }}
      >
        <DialogTitle>
          <Typography style={{ fontSize: "1.3rem" }} color="primary">
            How does course archiving work?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>
            Toggling this switch will archive/unarchive your course. Course data is not deleted when a course 
            is archived and remains fully visible to instructors. Archived courses are displayed under "Inactive 
            Courses" on instructors' sidebars but will no longer appear on students' and TAs' sidebars. 
          </Typography>
          {props.markedForArchiveDialog ? 
            <Typography style={{marginTop: 20}}>
              The flag icon next to the switch indicates that due to a long period of inactivity, your course has 
              been marked for archiving. If you are still actively using this course, please contact us. Otherwise, 
              we will eventually archive your course for you.
            </Typography> 
            : null
          }
        </DialogContent>
        <Button
          onClick={() => {
            props.closeArchiveCourseDialog();
          }}
          color="primary"
        >
          Close
        </Button>
      </Dialog>
    </>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(
      withWidth()(InstructorCourseSettingsDialogs)
    )
  )
);
